<template>
  <div class="questionnaire-score-matrix">
    <div v-if="!questions.length" class="text-body-2 grey--text">
      No scores to display.
    </div>

    <div
      v-for="(question, qi) in questions"
      :key="`q-${qi}-${question.question_id || question.header}`"
      class="mb-8"
    >
      <h3 class="mb-2">
        <v-chip
          v-if="question.question_key"
          class="mr-2"
          color="primary"
          small
          label
        >
          {{ question.question_key }}
        </v-chip>
        {{ question.question_title || question.header }}
      </h3>

      <v-simple-table dense class="elevation-1">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left" style="width: 25%">Option</th>
              <th class="text-left" style="width: 37.5%">
                Program Rank
                <span class="green--text font-weight-bold">
                  {{ formatScore(question.positive_score) }}
                </span>
              </th>
              <th class="text-left" style="width: 37.5%">
                Program Rank
                <span class="red--text font-weight-bold">
                  {{ formatScore(question.negative_score) }}
                </span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="!question.rows.length">
              <td colspan="3" class="grey--text">No scored options.</td>
            </tr>
            <tr
              v-for="(row, ri) in question.rows"
              :key="`r-${qi}-${ri}-${row.label}`"
            >
              <td>
                <strong>{{ row.label }}</strong>
                <div v-if="!row.option_id" class="caption red--text">
                  Option not matched in database
                </div>
              </td>
              <td>
                <v-chip
                  v-for="(p, idx) in row.positive"
                  :key="`pos-${idx}-${p.program_id}`"
                  class="ma-1"
                  color="green lighten-4"
                  small
                  label
                >
                  {{ p.name }}
                </v-chip>
                <span
                  v-if="
                    !row.positive.length &&
                      !unresolvedFor(row, 'positive').length
                  "
                  class="grey--text"
                >
                  &mdash;
                </span>
              </td>
              <td>
                <v-chip
                  v-for="(p, idx) in row.negative"
                  :key="`neg-${idx}-${p.program_id}`"
                  class="ma-1"
                  color="red lighten-4"
                  small
                  label
                >
                  {{ p.name }}
                </v-chip>
                <span
                  v-if="
                    !row.negative.length &&
                      !unresolvedFor(row, 'negative').length
                  "
                  class="grey--text"
                >
                  &mdash;
                </span>
              </td>
            </tr>
            <tr v-if="(question.unresolved_summary || []).length">
              <td colspan="3" class="yellow lighten-4 caption">
                Unresolved program names in this question:
                <v-chip
                  v-for="(name, idx) in question.unresolved_summary"
                  :key="`unresolved-${idx}`"
                  class="ma-1"
                  outlined
                  small
                  label
                >
                  {{ name }}
                </v-chip>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'QuestionnaireScoreMatrix',

  props: {
    questions: {
      type: Array,
      default: () => [],
    },
  },

  methods: {
    formatScore(score) {
      if (score === null || score === undefined) return ''
      return score > 0 ? `+${score}` : `${score}`
    },
    unresolvedFor(row) {
      return row.unresolved || []
    },
  },
}
</script>
